import theme from "styles/theme";

export const styles = {
    toolTipContent: {
        color: theme.palette.white,
    },
    callout: {
        beak: { background: theme.palette.darkerGrey },
        beakCurtain: { background: theme.palette.darkerGrey },
        calloutMain: {
            background: theme.palette.darkerGrey,
        },
    },
};
